import { render, staticRenderFns } from "./ClinicianRespondentHeader.vue?vue&type=template&id=f6d26e40"
import script from "./ClinicianRespondentHeader.vue?vue&type=script&lang=js"
export * from "./ClinicianRespondentHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports